import { render } from "./commonButton.vue?vue&type=template&id=3762b571&ts=true"
import script from "./commonButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./commonButton.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/shared/commonControls/commonButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3762b571"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3762b571', __exports__)) {
    api.reload('3762b571', __exports__)
  }
  
  module.hot.accept("./commonButton.vue?vue&type=template&id=3762b571&ts=true", () => {
    api.rerender('3762b571', render)
  })

}


export default __exports__